import { getToken } from "../utils/authUtils";
import { parseJSON } from "./parseJSON";

const urlBase = `${process.env.API_URL}/novedad/categories`;
const readUrl = (url = "") => `${urlBase}${url}`;

export const fetchPurchaseCategorias = async () => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(``), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};
